import { cn } from '~/lib/utils';

export const GridLine = () => {
  return (
    <>
      <div className={cn('hidden dark:block gridLineHorizontalDark ')} />
      <div className={cn('block dark:hidden gridLineHorizontal')} />
    </>
  );
};
